
import jsPDF from 'jspdf';
import 'jspdf-autotable';

declare module 'jspdf' {
  interface jsPDF {
    autoTable: (options: any) => jsPDF;
  }
}

export const exportPDF = (title: string, headers: string[], data: any[][]) => {
  const doc = new jsPDF({ orientation: 'landscape' });
  
  // Add title
  doc.setFontSize(16);
  doc.text(title, 15, 15);
  
  // Add date
  doc.setFontSize(10);
  doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 15, 25);
  
  // Add table
  doc.autoTable({
    startY: 35,
    head: [headers],
    body: data,
    theme: 'grid',
    styles: {
      fontSize: 8,
      cellPadding: 3
    },
    headStyles: {
      fillColor: [139, 69, 19], // Prince Jewelry burgundy
      textColor: 255
    }
  });
  
  // Save file
  const fileName = `${title.replace(/\s+/g, '_')}_${new Date().toISOString().slice(0, 10)}.pdf`;
  doc.save(fileName);
};

export const exportCompliancePDF = (data: any) => {
  const doc = new jsPDF();
  
  doc.setFontSize(18);
  doc.text('Prince Jewelry - Compliance Report', 20, 20);
  
  doc.setFontSize(12);
  doc.text(`Report Period: ${data.period}`, 20, 35);
  doc.text(`Generated: ${new Date().toLocaleDateString()}`, 20, 45);
  
  let yPos = 60;
  
  // GST Compliance
  doc.setFontSize(14);
  doc.text('GST Compliance Status', 20, yPos);
  yPos += 15;
  
  doc.setFontSize(10);
  doc.text(`GSTR-1 Filed: ${data.gst?.gstr1Filed ? 'Yes' : 'No'}`, 25, yPos);
  yPos += 10;
  doc.text(`GSTR-3B Filed: ${data.gst?.gstr3bFiled ? 'Yes' : 'No'}`, 25, yPos);
  yPos += 10;
  doc.text(`Total Tax Liability: ₹${data.gst?.totalTax || 0}`, 25, yPos);
  yPos += 20;
  
  // Quality Compliance
  doc.setFontSize(14);
  doc.text('Quality Compliance', 20, yPos);
  yPos += 15;
  
  doc.setFontSize(10);
  doc.text(`QC Inspections: ${data.quality?.totalInspections || 0}`, 25, yPos);
  yPos += 10;
  doc.text(`Pass Rate: ${data.quality?.passRate || 0}%`, 25, yPos);
  yPos += 10;
  doc.text(`Failed Items: ${data.quality?.failedItems || 0}`, 25, yPos);
  
  doc.save(`Compliance_Report_${new Date().toISOString().slice(0, 10)}.pdf`);
};
